var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pbar fCol aCenter jCenter",style:({width: ("" + _vm.wi), height: ("" + _vm.he)})},[_c('span',{staticClass:"secondary"}),_c('label',[_vm._v(_vm._s(_vm.msge))])])}
var staticRenderFns = []

export { render, staticRenderFns }